import { jsx as _jsx } from "react/jsx-runtime";
import { useComposerInputCommands } from '#pplx/frontend/composer-sdk/hooks/useComposerInputCommands.js';
import { useComposerInputTransforms } from '#pplx/frontend/composer-sdk/hooks/useComposerInputTransforms.js';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
export const TextPlugin = ({ contentEditable, ErrorBoundary, }) => {
    const [editor] = useLexicalComposerContext();
    // These commands/transforms define the Perplexity composer contract on top of
    // RichTextPlugin: paste rich content safely, keep decorator nodes usable, and
    // sanitize everything back into a visually plain single-paragraph input.
    useComposerInputCommands({ editor });
    useComposerInputTransforms({ editor });
    return _jsx(RichTextPlugin, { contentEditable: contentEditable, ErrorBoundary: ErrorBoundary });
};
//# sourceMappingURL=TextPlugin.js.map